import React, { createContext, useContext, useState } from 'react';

// 1. Crear el contexto
const InputChangedContext = createContext();

// 2. Hook para usar el contexto
export function useInputChanged() {
    //alert(InputChangedContext);
    return useContext(InputChangedContext);

}

// 3. Provider global
export function InputChangedProvider({ children }) {
    const [inputChanged, setInputChanged] = useState(false);
    const [validDataInputs, setValidDataInputs] = useState(false);
    const [saveFn, setSaveFn] = useState(null);

    return (
        <InputChangedContext.Provider value={{ inputChanged, setInputChanged, validDataInputs, setValidDataInputs, saveFn, setSaveFn }}>
            {children}
        </InputChangedContext.Provider>
    );
}
